import './index.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import EditChip from '../common/ActionChip/EditChip';
import RemoveChip from '../common/ActionChip/RemoveChip';
import CloseChip from '../common/ActionChip/CloseChip';


interface PrimaryMenuBarProps {
  action: string,
  setCurrentAction: (p: string) => void,
  handleRemove: () => void
  canEdit?: boolean,
}

const PrimaryMenuBar: React.FC<PrimaryMenuBarProps> = ({
  action,
  setCurrentAction,
  handleRemove,
  canEdit = false
}) => {
    const navigate = useNavigate()

    return (
      <React.Fragment>
        <div className='primary-menu-bar'>
          {action === 'view' && canEdit && (
            <EditChip
              label='Editar Elemento'
              onClick={() => setCurrentAction('edit')}
            />
          )}
          {action === 'view' && canEdit && (
            <RemoveChip
              label='Remover Elemento'
              onClick={handleRemove}
            />
          )}
          {action === 'edit' && (
            <CloseChip
              label='Cancelar Edición'
              onClick={() => navigate(0)}
            />
          )}
        </div>
      </React.Fragment>
    );
  }

export default PrimaryMenuBar;